import React from 'react';
import { CommissionDetailItem } from '../DetailItem/CommissionDetailItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { createStyles, Theme } from '@material-ui/core/styles';
import { ICommission, IUserEditState } from '../utils';
import TotalCommission from '../DetailItem/TotalCommission';
import { Button, Grid, Typography } from '@material-ui/core';
import CustomAccordion from '../../../../common/components/CustomAccordion/CustomAccordion';
import CustomValue, { ValueType } from './CustomValue';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

interface DistributeCommissionsProps {
  totalCommission: number;
  commissions: ICommission[];
  canEditUser: boolean;
  personelFullName?: string;
  onCommissionEditClick: (commission: ICommission) => void;
  onAddNewBeneneficiary: () => void;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
  getMaxCommissionCanBedAdd?: (args: number) => void | undefined;
  onRemoveBeneneficiaries: () => void;
  onCommissionDeleteClick: (commission: ICommission) => void;
}

export const DistributeCommissions: React.FC<DistributeCommissionsProps> = (
  props,
) => {
  const {
    onCommissionEditClick,
    onAddNewBeneneficiary,
    totalCommission,
    setUserState,
    getMaxCommissionCanBedAdd,
    canEditUser,
    onCommissionDeleteClick,
    personelFullName,
  } = props;
  const classes = useStyles();

  const [amountType, setAmountType] = React.useState<ValueType>('amount');

  const totalBeneficiaryCommissions = props?.commissions?.reduce(
    (acc, currentValue) =>
      currentValue?.amount ? currentValue?.amount + acc : acc,
    0,
  );

  const personalCommission = totalCommission - totalBeneficiaryCommissions;

  const handleAddBeneficiary = () => {
    onAddNewBeneneficiary();
  };

  const CalculPercentage = (amount: number) => (amount * 100) / totalCommission;

  const amountValue = (amount: number) =>
    amountType === 'percent' ? CalculPercentage(amount) : amount;

  React.useEffect(() => {
    if (getMaxCommissionCanBedAdd) {
      getMaxCommissionCanBedAdd(totalCommission - totalBeneficiaryCommissions);
    }
  }, [totalBeneficiaryCommissions, personalCommission]);

  return (
    <CustomAccordion title="Commission par défaut">
      <Grid container>
        <TotalCommission
          mutationVariableName="totalDefaultCommission"
          name="Total"
          value={totalCommission ? `${totalCommission}` : ''}
          placeholder="0"
          setUserState={setUserState}
        />

        <Grid item xs={12} className={classes.left}>
          <Typography className={classes.label}>Distribution :</Typography>
        </Grid>

        <CommissionDetailItem
          onEditClick={() => {
            onCommissionEditClick({} as any);
          }}
          valueComponent={
            <CustomValue
              beneficiaryName={personelFullName ?? 'Personnel'}
              amountDisplayinType={amountType}
              amount={amountValue(personalCommission)}
              onTypeAmountSelected={(amountType) => {
                setAmountType(amountType);
              }}
            />
          }
        />

        {props?.commissions?.map((commission, index) => (
          <CommissionDetailItem
            onDeleteClick={() => {
              onCommissionDeleteClick(commission);
            }}
            onEditClick={() => {
              onCommissionEditClick(commission);
            }}
            key={index}
            editable={canEditUser}
            valueComponent={
              <CustomValue
                amountDisplayinType={amountType}
                amount={amountValue(commission?.amount || 0)}
                beneficiaryName={`${commission?.beneficiary?.firstName} ${commission?.beneficiary?.lastName}`}
                onTypeAmountSelected={(amountType) => {
                  setAmountType(amountType);
                }}
              />
            }
          />
        ))}

        <Grid item xs={12} className={classes.center}>
          <Button
            color="secondary"
            variant="outlined"
            disabled={!totalCommission}
            onClick={handleAddBeneficiary}>
            Ajouter un bénéficiaire
          </Button>
        </Grid>
      </Grid>
    </CustomAccordion>
  );
};
